import React from "react";
import DatePicker from "./DatePicker";

const Solution = () => {
  return (
    <div className="p-4">
      <DatePicker />
    </div>
  );
};

export default Solution;
